import { trackClickEvent, trackClickEventHandler } from '../../events/clicks-tracker';
import { GabaritoAdsQuestionElement } from './interface';

export function handleEmptyAdFallback(
    slotElementId: string,
    adContainer: HTMLElement,
    overlayElement: HTMLElement,
    config?: GabaritoAdsQuestionElement
): void {
    adContainer.innerHTML = '';
    adContainer.classList.add('gabarito-ads__container--empty');
    
    const isEnemFallback = window.sg_gabarito_ads_config.fallbackLink === 'exercicios/exercicios-enem';
    const fallbackLinkUrl = `/${window.sg_gabarito_ads_config.fallbackLink}/` || '/exercicios/exercicios-enem/';
    const fallbackImageSrc = isEnemFallback ? '/img/banner/ad-enem.png' : '/img/banner/ad-tpc.png';
    const fallbackAltText = isEnemFallback ? 'Quer se garantir no ENEM? Tem mais questões te esperando' : 'Ainda não entendeu? O nosso ajudante de dever de casa te explica.';
    const trackValue = isEnemFallback ? 'cta-exercises-gabarito-ad' : 'cta-assistant-gabarito-ad';

    const imageLink = document.createElement('a');
    imageLink.href = fallbackLinkUrl;
    imageLink.classList.add('gabarito-ads__image-link');
    imageLink.setAttribute('data-track-click', trackValue);

    const imageElement = document.createElement('img');
    imageElement.src = fallbackImageSrc;
    imageElement.alt = fallbackAltText;
    imageElement.classList.add('gabarito-ads__image');
    imageLink.appendChild(imageElement);
    adContainer.appendChild(imageLink);

    if (!(imageLink as any).hasTrackClickListener) {
        imageLink.addEventListener('click', (clickEvent) => {
            trackClickEvent(trackValue);
        });
        (imageLink as any).hasTrackClickListener = true;
    }

    if (config?.type === 'hidden-content' && config.checkboxSelector) {
        const checkbox = document.querySelector(config.checkboxSelector) as HTMLInputElement;
        if (checkbox) {
            checkbox.disabled = false;
            console.log(`[Anúncio Vazio] Checkbox ${config.checkboxSelector} reativado.`);
        }
    }

    setTimeout(() => {
        overlayElement?.querySelectorAll('[data-track-click]').forEach((element) => {
            element.addEventListener('click', trackClickEventHandler);
        });
    }, 1);

    if (config) {
        const answerElement = document.querySelector(`#${config.id} ${config.answerSelector}`);
        if (answerElement) {
            (answerElement as HTMLElement).style.cssText = '';
            answerElement.classList.add('active');
        }
        if (config.type === 'hidden-content' && config.checkboxSelector) {
            const checkbox = document.querySelector(config.checkboxSelector) as HTMLInputElement;
            if (checkbox) {
                checkbox.checked = true;
                checkbox.disabled = false;
            }
        }
        config.hasShown = true;
    }
} 